import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";

const PARTNERS = [
  { name: "Strictly Building", years: "Ongoing partner", projects: 0 },
];

const PROOF_IMG =
  "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=2400&q=85";

export default function TradePartnership() {
  return (
    <section
      id="trade"
      data-testid={TID.trade.root}
      className="relative bg-sand py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="text-[11px] tracking-[0.32em] uppercase text-ink mb-8">
            Trade Partnership
          </p>
          <h2 className="font-display font-light text-[10vw] md:text-[4.6vw] leading-[1] tracking-tightest text-charcoal">
            The joinery partner builders keep coming back to.
          </h2>
          <p className="mt-8 text-ink text-lg leading-relaxed max-w-md">
            Most of our work each year is repeat work. Builders return because
            the units arrive measured, finished, and on time — every time.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="md:col-span-7 relative aspect-[4/3] overflow-hidden"
        >
          <img
            src={PROOF_IMG}
            alt="Builder partnership on site"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-charcoal/85 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12 text-cream">
            <p className="font-display text-2xl md:text-3xl leading-snug max-w-xl">
              "Mirabilis is the only joinery firm we use. They run their factory
              like we run our sites."
            </p>
            <p className="mt-5 text-[11px] tracking-[0.28em] uppercase text-cream/80">
              — Director, Strictly Building
            </p>
          </div>
        </motion.div>
      </div>

      <div className="mx-auto max-w-[1400px] px-6 md:px-12 mt-20 md:mt-28">
        <p className="text-[11px] tracking-[0.32em] uppercase text-ink mb-8">
          Ongoing builder partnerships
        </p>
        <div className={`${PARTNERS.length === 1 ? "" : "grid grid-cols-2 md:grid-cols-3 gap-x-8 md:gap-x-12 gap-y-8"} border-t border-stone pt-10`}>
          {PARTNERS.map((p) => (
            <motion.div
              key={p.name}
              data-testid={TID.trade.proof}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6 }}
              className={PARTNERS.length === 1 ? "" : "border-b border-stone pb-6"}
            >
              <p className="font-display text-2xl md:text-4xl text-charcoal">
                {p.name}
              </p>
              <p className="mt-3 text-[12px] tracking-[0.22em] uppercase text-ink/80">
                {p.projects > 0 ? `${p.years} · ${p.projects} projects` : p.years}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
